import { PageModel } from "./PageModel";

class JoinedPage extends PageModel {

}

export { JoinedPage }